(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Custom Dynamic Jump Menu (Table of Contents)
 * Requirements:
 * - A Content area with the class "js-jump-nav-sections"
 * - Each item in the ToCs should be it's own section
 * - A jump menu container with the class "js-jump-nav-menu"
 * - Jump menu should have link elements <a> equal to the number of sections in the content area (** This should be changed to be dynamic)
 */
var DyanmicTOC =
/*#__PURE__*/
function () {
  function DyanmicTOC() {
    _classCallCheck(this, DyanmicTOC);

    // Check if exists and initialize
    this.$dynamic_toc = $('.dynamic-toc');

    if (this.$dynamic_toc.length > 0) {
      this.init();
    }

    if (window.matchMedia("(max-width: 767px)").matches) {
      $(".dynamic-toc__contents").hide();
      $(".toggle-icon i").addClass('ti-plus');
      $(".toggle-icon i").removeClass('ti-minus');
    }

    $(".dynamic-toc__title").click(function () {
      $(".dynamic-toc__contents").toggle(200);
      $(".toggle-icon i").toggleClass('ti-minus ti-plus');
    });
  }

  _createClass(DyanmicTOC, [{
    key: "init",
    value: function init() {
      // Initialize component(s)
      this.toc_contents = this.$dynamic_toc.find('.dynamic-toc__contents').get(0);
      this.$toc_title = this.$dynamic_toc.find('.dynamic-toc__title');
      this.content_selector = this.$dynamic_toc.data('content');
      this.headings_selector = this.$dynamic_toc.data('headings');
      this.$content = $(this.content_selector).first();
      this.$headings = this.$content.find(this.headings_selector);
      this.toc_array = new Array();

      if (!this.$content || !this.$headings) {
        console.log('Could not locate contents or headings...');
        return;
      }

      this.prepareHeadings();
      this.populateToc();
      this.observeElements();
    }
  }, {
    key: "prepareHeadings",
    value: function prepareHeadings() {
      var _this = this;

      this.$headings.each(function (index, element) {
        var element_text = _this.replaceNbsps(element.textContent);

        var element_id = element_text.replace(/[^a-zA-Z0-9 ]/g, '').replaceAll(' ', '-').toLowerCase();
        element.id = element_id;
        var level = element.tagName.replace("H", "");
        var toc_item = {
          id: element_id,
          text: element_text,
          level: level //element: element,

        };

        _this.toc_array.push(toc_item);
      }); //console.log( this.toc_array );
    }
  }, {
    key: "replaceNbsps",
    value: function replaceNbsps(str) {
      var re = new RegExp(String.fromCharCode(160), "g");
      return str.replace(re, " ");
    }
  }, {
    key: "populateToc",
    value: function populateToc() {
      if (this.toc_array.length == 0) {
        this.$dynamic_toc.addClass('d-none');
      } else {
        this.toc_contents.innerHTML = this.buildTree(this.toc_array);
        this.$toc_items = this.$dynamic_toc.find('.dynamic-toc__contents li');
      }
    }
  }, {
    key: "buildTree",
    value: function buildTree(headers) {
      var _this2 = this;

      //Code from: https://stackoverflow.com/questions/63218812/how-to-create-a-nested-list-elements-of-heading-tags-in-the-same-order-from-dom
      var list = [];
      var nextLevelHeaders = [];
      var lastLevel = -1;

      if (headers.length === 0) {
        return "";
      }

      var buildSubTree = function buildSubTree() {
        if (nextLevelHeaders.length > 0) {
          list[list.length - 1] += _this2.buildTree(nextLevelHeaders); //console.log(list);
        }
      };

      headers.forEach(function (h) {
        if (lastLevel !== -1 && lastLevel < h.level) {
          nextLevelHeaders.push(h);
          return;
        }

        buildSubTree();
        lastLevel = h.level;
        list.push("<a class=\"toc__link\" href=\"#".concat(h.id, "\">").concat(h.text, "</a>"));
        nextLevelHeaders = [];
      });
      buildSubTree();
      var listHTML = list.map(function (i) {
        return "<li class=\"toc__item\">".concat(i, "</li>");
      }).join("");
      return "<ul class=\"toc__list\">".concat(listHTML, "</ul>");
    }
  }, {
    key: "observeElements",
    value: function observeElements() {
      var _this3 = this;

      this.sectionObserver = new IntersectionObserver(function (changes, observer) {
        _this3.sectionIntersection(changes, observer);
      }, {
        rootMargin: "-80px 0px -80px 0px",
        threshold: 0
      });
      this.$headings.each(function (index, element) {
        _this3.sectionObserver.observe(element);
      });
    }
  }, {
    key: "sectionIntersection",
    value: function sectionIntersection(changes, observer) {
      var _this4 = this;

      changes.forEach(function (change) {
        var isIntersecting = change.isIntersecting;
        var target = change.target;

        if (isIntersecting) {
          var sectionId = target.getAttribute('id');
          var linkHref = "#" + sectionId;

          _this4.$toc_items.removeClass('active');

          _this4.$dynamic_toc.find('a[href="' + linkHref + '"]').closest('.toc__item').addClass('active');
        }
      });
    }
  }]);

  return DyanmicTOC;
}();

var _default = DyanmicTOC;
exports.default = _default;

},{}],2:[function(require,module,exports){
"use strict";

var _dynamicToc = _interopRequireDefault(require("./modules/dynamic-toc"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Manage global libraries like jQuery or THREE from the package.json file
 */
window.$ = jQuery; // import BackToTop from './modules/back-to-top';
// import SocialSharePopups from './modules/dynamic-toc';

$(document).ready(function () {
  $('html').addClass('js-on-load'); // const backToTop = new BackToTop();
  //  const socialSharePopups = new SocialSharePopups();

  var dynamicToc = new _dynamicToc.default(); // plugin('ResponsiveTabs', ResponsiveTabs);
});

},{"./modules/dynamic-toc":1}]},{},[2]);
